import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { RemodelOperationalProjectTemplate as template } from './remodel-operational-projects.template';
import { RemodelOperationalProjectStyles as styles } from './remodel-operational-projects.styles';
import { IProjectModalService } from '../../../../services/project_modal.service';
import { Project } from '../../../../types';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { TECHNOLOGY } from '../../../../utils';
import { stringSimilarity } from 'string-similarity-js';

const name = 'remodel-operational-projects';

export interface IRemodelOperationalProjectObject {
  REMODEL_PROJECT_ID;
  NAME;
  LATITUDE;
  LONGITUDE;
  ISO_STRING;
  COD;
  AVAILABLE_CAPACITY_AC;
  TECHNOLOGY_STRING;
  AVAILABLE_CAPACITY_DC;
  TRACKING_TYPE_STRING;
  PANEL_TYPE_STRING;
  PANEL_TECHNOLOGY_STRING;
  TURBINE_COUNT;
  TURBINE_DIAMETER;
  HUB_HEIGHT;
  NAME_SIMILARITY;
}

@customElement({
  name,
  template,
  styles,
})
export class RemodelOperationalProject extends FASTElement {
  @attr project: Project;
  @IProjectModalService projectModalService: IProjectModalService;
  @observable remodelProjectsGrid: zeroAgGrid;
  @observable selectedRemodelProjectId: string = '';

  private projectsData: IRemodelOperationalProjectObject[] = [];

  connectedCallback() {
    super.connectedCallback();
    this.loadRemodelProjects();

    const gridOptions = {
      animateRows: true,
      suppressRowClickSelection: true,
      suppressBrowserResizeObserver: true,
    };

    this.remodelProjectsGrid.gridOptions = gridOptions;
  }

  async loadRemodelProjects() {
    const response = await this.projectModalService.getRemodelOperationalProjects(
      this.project.ISO,
      this.project.TECHNOLOGY === TECHNOLOGY.SOLAR ? 'Solar' : 'Wind',
      false
    );
    if (response.REPLY) {
      this.projectsData = response.REPLY;
      this.projectsData.forEach((remodelProject) => {
        const similarity = stringSimilarity(this.project.NAME, remodelProject.NAME);

        remodelProject.NAME_SIMILARITY = similarity;
      });
      this.projectsData = this.projectsData.filter(
        (remodelProject) => remodelProject.NAME_SIMILARITY && remodelProject.NAME_SIMILARITY !== 0
      );
      this.projectsData.sort((a, b) => {
        if (a.NAME_SIMILARITY && b.NAME_SIMILARITY) {
          return b.NAME_SIMILARITY - a.NAME_SIMILARITY;
        } else {
          return 0;
        }
      });
      if (this.remodelProjectsGrid?.gridApi) {
        this.remodelProjectsGrid.gridApi.setRowData(this.projectsData);
      }
    }
  }

  onGridReady() {
    this.selectedRemodelProjectId = '';
    this.remodelProjectsGrid.gridApi.setRowData(this.projectsData);
  }

  public selectProject(remodelProject: IRemodelOperationalProjectObject) {
    this.$emit(
      'remodelProjectSelected',
      remodelProject.REMODEL_PROJECT_ID !== '' ? remodelProject.REMODEL_PROJECT_ID : null
    );
    this.selectedRemodelProjectId = remodelProject.REMODEL_PROJECT_ID;
    this.remodelProjectsGrid.gridApi.redrawRows();
  }
}
